import { getAPIFromDomain } from "../../lib/api";
import { Common } from "@secondcloset/types";

export type Facility = Common.Facility<"V2"> & {
  location: { latitude: number; longitude: number };
};
export const fetchFacilityIndex = async (): Promise<Facility[]> => {
  const api = getAPIFromDomain(undefined, 2);
  const res = await api.get("/facilities");
  return res.data;
};
